const messages = {
    accountBox: {
        title: "Kontrolna tabla",
        description: "Brzo pratite svoje promocije i bodove.",
        button: "OTVORI KONTROLNU TABLU",
    },
};

export default {
    messages,
};
